<template>
    <section class="section container">
        <div class="row">
            <div class="col-12">
                <!-- <h3>Search bar and top filters</h3> -->
                <form ref="filterControls" class="dmi-filter-search__box" @submit.prevent="handleSearchClick">
                    <div class="dmi-filter-search__wrapper">
                        <input type="text" class="dmi-filter-search__input" name="Search" id="" placeholder="Search recipes" v-model="searchTerm" @input="handleSearchTyping" />
                        <button type="button" class="dmi-filter-search__clear" @click.prevent="handleSearchReset" v-if="searchTermStatic.length >= 1">
                        </button>
                        <button type="submit" class="dmi-filter-search__link" aria-label="Filter Search Button">
                            <span class="dmi-filter-search__icon"></span>
                        </button>
                    </div>
                </form>
                 <recipe-chip-list></recipe-chip-list>
            </div>
            <div class="col-12 col-lg-3">
                <!-- <h3>Side filters</h3> -->
                <recipe-facets-filter :filters="filters"></recipe-facets-filter>

                <!-- <filter-sidebar v-for="(filter, key, index) in filters" v-bind:key="key" v-bind:filters="filter.Options" v-bind:title="filter.Label"></filter-sidebar> -->
            </div>
            
            <div class="col-12 col-lg-9">
                <div class="row recipe-listing-card-grid" v-if="listing.length">
                    <summary-item v-for="(item, index) in listing" v-bind:item="item" v-bind:key="item.DetailID"></summary-item>
                </div>
                <recipe-no-results
                    v-else
                    :search-term="searchTermStatic"
                    @clear="handleSearchReset"
                ></recipe-no-results>
                <pagination v-if="listing.length"></pagination>
            </div>
        </div>
    </section>
</template>

<script>
    import SmoothScroll from 'smooth-scroll';
    import {mapState, mapActions, mapMutations} from 'vuex';
    import FilterSidebar from '../components/listing/filter-sidebar';
    import SummaryItem from '../components/listing/recipe-listing-card';
    import RecipeChipList from '../components/listing/recipe-chip-list';
    import RecipeFacetsFilter from '../components/listing/recipe-facets-filter';
    import RecipeNoResults from '../components/listing/recipe-no-results';
    import Pagination from '../components/listing/pagination-dropdown';

    export default {
        props: ['filterid', 'filtertype', 'result', 'resource', 'title'],   
        data: function () {
            return {
                searchTerm: '',
                searchTermStatic: '',
                filters: {},
                chipLists: {}
            }
        },
		computed: mapState({
            loading: state => state.listing.loading,
            listing: state => state.listing.listing,
            pagination: state => state.listing.pagination,
        }),
        components: {
            'filter-sidebar': FilterSidebar,
            'recipe-chip-list': RecipeChipList,
            'recipe-facets-filter': RecipeFacetsFilter,
            'recipe-no-results': RecipeNoResults,
            'summary-item': SummaryItem,
            pagination: Pagination
        },
        mounted: function () {
            let _this = this;
            _this.filters = window.Launchpad.RecipeFilters;
            
            this.setInitData(this.result);
            this.setResource(this.resource);

            let scroll = new SmoothScroll();
            let options = {
                header: '[data-scroll-header]',
                speed: 1000
            };

            this.$store.subscribeAction((action, state) => {
                if (action.type === 'listing/setFilter') {
                    let anchor = _this.$refs.filterControls;
                    const scrollOptions = {
                        ...options,
                        offset: window.matchMedia('(max-width: 768px)').matches ? 50 : 0
                    };

                    if (this.isElementVisible(anchor)) {
                        return;
                    }

                    scroll.animateScroll(anchor, null, scrollOptions);
                }
            });

            this.$store.subscribe((mutation, state) => {
                if (mutation.type === 'listing/updateSpecification') {
                    this.setFilter();
                }
            });
        },
        methods: {
            ...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', {setInitData: 'setInitData' }),
			...mapMutations('listing', {setResource: 'setResource' }),
			...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
            ...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
            resetFilters() {
		        this.resetSpecification();
            },
            handleSearchReset(e) {
                this.searchTerm = '';
                this.searchTermStatic = '';
                this.resetSpecification();
                this.setFilter();
            },
            handleSearchTyping(e) {
                this.searchTerm = e.target.value;
            },
            handleSearchClick(e) {
                this.searchTermStatic = this.searchTerm;
                this.updateSpecification({ key: 'SearchTerm', value: this.searchTerm });
            },
            isElementVisible(element) {
                if (!element) {
                    return false;
                }

                const rect = element.getBoundingClientRect();
                return rect.top >= 0 && rect.bottom <= window.innerHeight;
            }
        }
    }
</script>
